// extracted by mini-css-extract-plugin
export default {"page":"Page-page-TorHA","main":"Page-main-Swphf"};